import React from "react";

import classes from "./InputBox.module.css";

const InputBox = ({
  label,
  labelFor,
  optional,
  children,
  className,
  ...props
}) => (
  <div className={className} {...props}>
    <label className={[classes.labelStyle]} htmlFor={labelFor}>
      {label}
      {!optional && `*`}
    </label>
    {children}
  </div>
);

export default InputBox;
